export default "__VITE_ASSET__ugPTSxP1__"